var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._l((_vm.errorList),function(error){return _c('div',{key:error,staticClass:"text-danger",attrs:{"aria-live":"polite","role":"region","aria-label":"Errors"}},[_vm._v(_vm._s(error))])})}
var staticRenderFns = []

export { render, staticRenderFns }